import { useMemo } from 'react';
import { PagesFragment, usePagesQuery } from '../generated/graphql';
import { REGISTRY_PAGE_TYPE } from './pages';

export const useRegistryPage = (): PagesFragment | undefined => {
  const { data } = usePagesQuery();
  return useMemo(() => {
    return data?.pages?.find(p => p.type === REGISTRY_PAGE_TYPE);
  }, [data]);
};
